import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-newVipIcon7",
  "use": "icon-newVipIcon7-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-newVipIcon7\"><title>1.Base基础/3.Icon图标/其他/server</title><path fill-rule=\"evenodd\" d=\"M1.25 2.5h12.5v3.75h5V17.5H1.25zm16.43 4.594L10 7.5l-7.8-.406.3 4.781-.3 4.728 7.8-.353 7.79.353-.29-4.728zm-4.864-3.787L7.5 3.75l-5.3-.443L2.5 5l-.3 1.63 5.3-.38 5.316.38L12.5 5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol